import { Injectable } from '@angular/core';
import { ApiService } from '@targx/services/api/api.service';
import { combineLatest } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TxDragDropService {
  private fileQueue: File[] = [];

  private _zone = 'zone';

  constructor(private api: ApiService) {
    console.log('TxDragDropService');
  }

  /**
   * Uploads the files in the queue to the specified endpoint.
   */

  get files() {
    return this.fileQueue;
  }

  set files(files: File[]) {
    this.fileQueue = files;
  }

  set append(file: File) {
    this.fileQueue.push(file);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  upload(endpoint: string, params?: any) {
    const formData = {
      files: this.fileQueue,
      ...params,
    };

    console.log('formData', formData);

    // After submitting the form, reset the file queue
    return this.api.raw(endpoint, 'POST', formData); //.pipe(tap(() => this.reset()));
  }

  uploadMulti(endpoint: string, params?: any) {
    const filesToUpload = this.fileQueue.map((file) => {
      return this.uploadOne(endpoint, file, params);
    });

    return combineLatest(filesToUpload);
  }

  private uploadOne(endpoint: string, file: File, params?: any) {
    const formData = {
      files: file,
      ...params,
    };

    console.log('formData', formData);

    // After submitting the form, reset the file queue
    return this.api.raw(endpoint, 'POST', formData); //.pipe(tap(() => this.reset()));
  }

  reset() {
    this.fileQueue = [];
  }
}
